/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estado inicial del suscriptor
 */
export const INITIAL_SUBSCRIBER_STATE = {
  uuid: null,
  first_name: '',
  last_name: '',
  dni: '',
  gender: '',
  cuit: '',
  birth_date: '',
  address: '',
  postal_code: '',
  phone: '',
  email: '',
  uuid_nationality: '',
  uuid_marital_status: '',
  uuid_iva_condition: '',
  uuid_country: '',
  uuid_province: '',
  uuid_department: '',
  uuid_district: '',
  observations: '',
};

/**
 * Opciones de género
 */
export const GENDER_OPTIONS = [
  { value: 'h', label: 'Masculino' },
  { value: 'm', label: 'Femenino' },
  { value: 'O', label: 'Otro' },
];

/**
 * Configuración de validaciones
 */
export const VALIDATION_RULES = {
  DNI: {
    MIN_LENGTH: 7,
    MAX_LENGTH: 8,
    PATTERN: /^\d+$/,
  },
  CUIT: {
    LENGTH: 11,
    PATTERN: /^\d{11}$/,
  },
  EMAIL: {
    PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  PHONE: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 15,
    PATTERN: /^[\d\s()+-]+$/,
  },
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Suscriptor creado exitosamente',
    UPDATE: 'Suscriptor actualizado exitosamente',
    DELETE: 'Suscriptor eliminado exitosamente',
  },
  ERROR: {
    CREATE: 'Error al crear el suscriptor',
    UPDATE: 'Error al actualizar el suscriptor',
    DELETE: 'Error al eliminar el suscriptor',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_DNI: 'DNI inválido',
    INVALID_CUIT: 'CUIT inválido',
    INVALID_EMAIL: 'Email inválido',
    INVALID_PHONE: 'Teléfono inválido',
  },
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  firstName: { width: '15%' },
  lastName: { width: '15%' },
  dni: { width: '12%' },
  address: { width: '25%' },
  district: { width: '15%' },
  actions: { width: '18%' },
};
